  <div *ngIf="view.enableExternalLink" [class]="infoClasses" role="button">
    <a href="{{view.externalLink}}" target="_blank">
      <co-image [width]="view.helpIconWidth" [height]="view.helpIconHeight" type="svg" key="link" imageSet="{{imageSet}}"></co-image>
    </a>
  </div>

  <div *ngIf="!view.enableExternalLink" [class]="infoClasses" role="button">
    <co-image [width]="view.helpIconWidth" [height]="view.helpIconHeight" type="svg" key="info" imageSet="{{imageSet}}"></co-image>
  </div>